import { Form, Formik } from 'formik';
import React, { Dispatch, SetStateAction, useEffect } from 'react';

import { PrimaryButton } from '@components/Button/variants';
import OAuthOption from '@components/EmailLeadCapture/OAuthOption';
import TextField from '@components/Form/TextField';
import useLoginByEmail from '@hooks/useLoginByEmail';
import { READER_URL } from '@src/env';
import { LeadTypes } from '@utils/enums';

import { FormRenderMap } from './NewSessionPage';
import validationSchema from './validationSchema';

interface EmailFormParams {
  email: string;
  returningUrl: string | null;
  setEmail: Dispatch<SetStateAction<string>>;
  setCurrentForm: Dispatch<SetStateAction<string>>;
  setReturningUrl: Dispatch<SetStateAction<string>>;
}

const EmailForm: React.FC<EmailFormParams> = ({
  email,
  returningUrl,
  setEmail,
  setCurrentForm,
  setReturningUrl,
}) => {
  const redirectToOnSuccess = returningUrl || READER_URL;
  const {
    mutateAsync: loginByEmailMutateAsync,
    isLoading: loginByEmailIsLoading,
    data: loginByEmailResponse,
  } = useLoginByEmail();

  useEffect(() => {
    if (!loginByEmailIsLoading && loginByEmailResponse) {
      setEmail(loginByEmailResponse.email);
      if (loginByEmailResponse.returningUrl) {
        setReturningUrl(loginByEmailResponse.returningUrl);
      }
      if (loginByEmailResponse.render) {
        setCurrentForm(FormRenderMap[loginByEmailResponse.render]);
      }
      if (loginByEmailResponse.redirectUrl) {
        window.location.href = loginByEmailResponse.redirectUrl;
      }
    }
  }, [loginByEmailIsLoading, loginByEmailResponse, setCurrentForm, setEmail, setReturningUrl]);

  const handleSubmit = (values) => {
    loginByEmailMutateAsync({ email: values.email, returningUrl: returningUrl });
  };

  const initialValues = {
    email: email,
  };

  return (
    <>
      <div className="flex flex-col justify-center text-center font-suisse-works">
        <div className="mb-6 text-headline-md lg:text-headline-xl">Welcome back</div>
      </div>
      <div className="mt-2 w-full">
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
          validateOnMount={false}
          validateOnChange={false}
          validateOnBlur={false}
        >
          {(formik) => (
            <Form id="new_registration">
              <TextField
                id="login-email"
                name="email"
                placeholder="Enter your email"
                type="email"
                autoFocus
              />
              <PrimaryButton
                as="button"
                className="mt-8 w-full"
                isLoading={loginByEmailIsLoading}
                disabled={formik.isSubmitting}
              >
                Continue with email
              </PrimaryButton>
            </Form>
          )}
        </Formik>

        <div className="flex flex-col justify-center py-20">
          <div className="mx-auto mt-8">
            <OAuthOption
              articleId={null}
              expandable={false}
              isGdprOptIn={null}
              isVertical={false}
              leadType={LeadTypes.Organic}
              newsletterIds={[]}
              oauthButtonsClassName="py-4"
              redirectToOnSuccess={redirectToOnSuccess}
              shareGuid={''}
              unlockContent={false}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default EmailForm;
